import { get } from 'lodash'
import { createSelector } from 'reselect'

export const getAttendantSettingsByEmployeeUuid = (state) => get(state, 'appDeviceConfiguration.byEmployeeId')
export const getAttendantSettingsByEmployeeUuidAndEventId = (state, eventId) => get(state, `appDeviceConfiguration.byEventId.${eventId}.byEmployeeId`)

const getAttendantSetting = (state, employeeUuid) => get(state, `appDeviceConfiguration.byEmployeeId.${employeeUuid}`)
const getAttendantEventSetting = (state, employeeUuid, eventUuid) => get(state, `appDeviceConfiguration.byEventId.${eventUuid}.byEmployeeId.${employeeUuid}`)

export const makeGetAttendantSetting = () => createSelector([getAttendantSetting], (setting) => setting)
export const makeGetAttendantEventSetting = () => createSelector([getAttendantEventSetting], (setting) => setting)

export const getAttendantByStandUuidAndEventId = (state, eventId) => get(state, `appDeviceConfiguration.byEventId.${eventId}.byStandUuid`)

export const getAttendantSettingIsLoading = (state) => state?.appDeviceConfiguration?.isLoading ?? false
